import {useDispatch} from 'react-redux';
import ContentCardWrapperV4 from '../../../common/component/ContentCardWrapperV4';
import FetchResultWrapper from '../../../common/component/FetchResultWrapper';
import {actions as commonSubActions} from '../../../commonSub/state/action';
import {IUseTicketParams} from '../../../commonSub/type';
import {sendHomeEvent} from '../../common/tracking';
import MyContentCardV4 from '../component/MyContentCardV4';
import TextWithArrowV4 from '../component/TextWithArrowV4';
import ToggleWithContentV4 from '../component/ToggleWithContentV4';
import {IClickContentProps, IEditPropsV4, IRecentV4} from '../type';

interface IProps extends IEditPropsV4, IClickContentProps {
  recent?: IRecentV4;
}

export default function RecentTabV4({
  recent,
  isEdit,
  showLoading,
  selectedList = {},
  onToggle,
  onClickContent,
}: IProps) {
  const dispatch = useDispatch();
  const handleClickEpisode = ({
    recentId,
    contentId,
    contentSid,
    episodeId,
    episodeSid,
    index,
    isFree,
  }: IUseTicketParams & {recentId: number | string; index: number}) => {
    sendHomeEvent({
      actionName: 'episode',
      action: 'click',
      customProps: {
        content_id: contentId,
        episode_id: episodeId,
        ordnum: index + 1,
        event_layer: 'section',
      },
    });

    isEdit
      ? onToggle?.(recentId)
      : dispatch(
          commonSubActions.fetchUseTicket({
            contentId,
            contentSid,
            episodeId,
            episodeSid,
            isCheckNextEpisode: true,
            isFree,
          })
        );
  };

  // 최근 감상은 로그인이 필요 없기 때문에 NoItems 컴포넌트만 사용 (NoLogin 필요 없음)
  return (
    <FetchResultWrapper
      showLoading={!recent || showLoading}
      showNoItems={!!recent && recent.contents.length === 0}
      noItemsProps={{
        textKey: 'library_tab_recent_empty',
      }}
    >
      <ContentCardWrapperV4>
        {(recent?.contents || []).map(
          ({id: recentId, episode, content}, index) => (
            <MyContentCardV4
              key={content.id}
              content={isEdit ? {...content, badges: []} : content}
              isDimmed={selectedList[recentId]}
              onClick={
                onClickContent
                  ? () => onClickContent(content, index)
                  : () => onToggle?.(recentId)
              }
              onClickBottom={() =>
                handleClickEpisode({
                  recentId,
                  contentId: content.id,
                  contentSid: content.sid,
                  episodeId: episode.id,
                  episodeSid: episode.sid,
                  isFree: episode.type === 'free',
                  index,
                })
              }
            >
              <ToggleWithContentV4
                toggleType="checkbox"
                showToggle={isEdit}
                isSelected={selectedList[recentId]}
              >
                <TextWithArrowV4 text={episode.title} />
              </ToggleWithContentV4>
            </MyContentCardV4>
          )
        )}
      </ContentCardWrapperV4>
    </FetchResultWrapper>
  );
}
